import React from 'react';
import { MailConversationsList } from '../components/common/MailConversationsList';
import TopBarLayout from '../components/common/layout/TopBarLayout';
import LivePage from './LivePage';
import submenuEmails from './menus/submenu-emails';
import _ from 'lodash';
import FiltersBar from '../components/common/filters-bar/FiltersBar';
import MultiButtonSwitch from '../components/common/editors/MultiButtonSwitch';
import InputUserId from '../components/common/InputUserId';
import { IconButton } from '../components/common/IconButton';
import { SwitchInput } from '../components/common/SwitchInput';

export default class UserConversationsViewer extends LivePage {
  constructor(... params) {
    super(... params);

    this.state.userId = this.getUrlParam('userId') || '';
    this.state.mailType = this.getUrlParam('mailType') || 'all';
    this.state.onlyUnread = this.getUrlParam('onlyUnread') || false;

    this.fullScreen = true;
    this.submenu = submenuEmails;

    this.conversations = this.service('services/data/emails/conversations');
  }

  async queryConversations() {
    const { mailType, userId, onlyUnread } = this.state;

    const lastIncomingMails = {
      $sort: '-date',
      $limit: 100,
      $select: {threadId: 1, date: 1},
      ... (onlyUnread ? {read: false} : {}),
      ... (mailType !== 'all' ? {type: mailType} : {})
    }

    if(userId?.length) {
      lastIncomingMails.userId = {$in: userId};
    }


    const messages = await this.conversations.find({query: lastIncomingMails})

    console.log(messages.length+" EMAILS", lastIncomingMails)

    this.setState({threadIds: _.uniq(_.map(messages, 'threadId'))})
  }

  componentDidMount() {
    super.componentDidMount();
    this.queryConversations().catch(alert);
  }

  updateFilter(field, value) {
    this.setState({[field]: value}, () => this.queryConversations());

    if (value !== undefined && !_.isEmpty(value)) {
      this.setUrlParam(field, value);
    } else {
      this.deleteUrlParam(field);
    }
  }

  renderPageBody() {
    let {userId, threadIds, mailType, onlyUnread} = this.state;

    const filter = userId?.length ? {userId} : {threadIds};

    const onUserIdChange = id => this.updateFilter('userId',id);
    const onMailTypeChange = type => this.updateFilter('mailType', type);

    return <TopBarLayout>
      <FiltersBar>
        <MultiButtonSwitch value={mailType} onChange={onMailTypeChange} options={['sent', 'received', 'all']}/>

      <div className={'no-wrap ml-1'}>
        <SwitchInput value={onlyUnread} onChange={(v) => this.updateFilter('onlyUnread', v)}>Only unread</SwitchInput>
      </div>

        <InputUserId className={'ml-3 w-75'} isClearable={true} value={userId} onChange={id => onUserIdChange(id)} isMulti/>

        <IconButton className={'ml-3'} icon={'create'} onClick={() => this.setUrlParam('editing', true)} title={'Create new email'}/>
      </FiltersBar>

      <MailConversationsList {... filter}/>
    </TopBarLayout>
  }
}
